module.exports = ".bottomMargin {\n  margin-bottom: 10px;\n  margin-left: 0; }\n"